import React from 'react';
import Column from '../../column';
import Title from './title';
import Wrapper from './wrapper';
import ListItem from './list-item';
import Ul from './ul/index';

// @TODO: split this component in the new Ul and other types of lists.
// the current wrapper/list-item if/else variant is a mess..

const List = ({
  // id,
  columnWidth,
  align,
  justify,
  order,
  card,
  title,
  variant,
  listitems,
  offset,
}) => (
  <Column
    columnWidth={columnWidth}
    align={align}
    justify={justify}
    card={card}
    order={order}
    offset={offset}
  >
    {title && <Title $variant={variant}>{title}</Title>}
    {variant === 'bullet' && (
      <Ul
        items={listitems}
      />
    )}
    {variant === 'ordered' && (
      <Ul
        Tag="ol"
        items={listitems}
      />
    )}
    {!['bullet', 'ordered'].includes(variant) && (
      <Wrapper $variant={variant} $columnWidth={columnWidth}>
        {(listitems || []).map(({
          id,
          ...item
        }) => (
          <ListItem
            key={id}
            variant={variant}
            {...item}
          />
        ))}
      </Wrapper>
    )}
  </Column>
);

export default List;
